<template>
<!-- eslint-disable max-len -->
<div class="paragraphs">
  <slot v-if="false"></slot>
  <p class="paragraph" v-for="(paragraph, i) in paragraphs" :key="i" :style="paragraphStyle">{{ paragraph }}</p>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    noMargin: { type: Boolean },
    fontSize: { type: String },
    // use this for dynamic content
    // slots do not refresh reactively after first render
    text: { type: String }
  },
  computed: {
    ...mapGetters([
      'newlineRegex'
    ]),
    paragraphs() {
      let text;
      if (this.text) {
        text = this.text;
      } else {
        const { default: defaultSlot } = this.$slots;
        text = ((defaultSlot || [])[0] || {}).text;
      }
      return text.split(this.newlineRegex);
    },
    paragraphStyle() {
      return {
        fontSize: this.fontSize || 'inherit',
        'margin-bottom': this.noMargin ? 0 : '15px'
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.paragraph:last-of-type {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/display/Paragraphs.vue